import React from "react";
import PropTypes from "prop-types";
import { Menu, Button, Popover } from "antd";

import { enquireScreen } from "enquire-js";
// import websiteLogo from "../assets/imgs/website-logo.png";
import websiteLogo from "../assets/imgs/home/组 4200@2x.png";
import "./static/header.less";
import downloadImg from "../assets/imgs/home/下载@2x.png"
import downloadLogo from "../assets/imgs/home/downloadLogo.webp"
import downloadLeft from "../assets/imgs/home/downloadLeft.webp"

import { canGoMarket } from "../utils/tools";
import UserAgentConponents from "../components/UserAgentConponent";
import DownloadComponent from "../components/DownloadComponent";

import { downloadClick, getDownloadUrl } from "../utils/common";

class Header extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    isMobile: PropTypes.bool,
    activeFAQ: PropTypes.bool,
    activePrivacy: PropTypes.bool,
    activeProduct: PropTypes.bool,
    activeHome: PropTypes.bool,
    handleclick: PropTypes.func,
  };

  state = {
    menuVisible: false,
    menuMode: "horizontal",
    downloadUrl: "",
    userAgentVisible: false,
    downLoanApkUrl: '',
    showDownloadModal: false,
  };

  componentDidMount() {

    const url = getDownloadUrl();
    this.setState({downLoanApkUrl: url})
    enquireScreen((b) => {
      this.setState({ menuMode: b ? "inline" : "horizontal" });
    });
  }

  handleShowMenu = () => {
    // console.log("handleShowMenu", this.state.menuVisible);
    this.setState({ menuVisible: !this.state.menuVisible });
  };

  handleMenuClick = (event) => {
    this.handleclick(event.key);
    this.setState({ menuVisible: false });
  };

  handleclick = (id) => {
    console.log('jumpToSection',id)
    if(id === 'FAQ'){
      window.location.href = '/faq'
        // history.push('/faq');  // 用来导航到 FAQ 页面
    }
    if(id === 'Home'){
      window.location.href = '/'
    }
    if(id === 'PrivacyPolicy'){
      window.location.href = '/privacyAgreement'
    }
    if(id === 'Download'){
      this.setState({
        showDownloadModal: true,
      })
      // setTimeout(() => {
      //   let deviceType = canGoMarket();
      //   if (deviceType) {
      //     this.setState({userAgentVisible: true})
      //   } else {
      //     downloadClick();
      //   }
      // }, 1000);


    }
  };

  render() {
    const { activeFAQ, activeHome, isMobile, activePrivacy } =
      this.props;
    const { menuMode, menuVisible, downLoanApkUrl, userAgentVisible, showDownloadModal } = this.state;

    const menu = (
      <Menu
        mode="inline"
        id="nav"
        key="nav"
        onClick={(e) => this.handleMenuClick(e)}
      >
        <Menu.Item key="Home">
          <span>Borrow</span>
        </Menu.Item>
        <Menu.Item key="FAQ">
          <span>FAQ</span>
        </Menu.Item>
        <Menu.Item key="PrivacyPolicy">
          <span>Privacy Policy</span>
        </Menu.Item>
        {/* <Menu.Item key="blogs">
          <span>Blogs</span>
        </Menu.Item> */}
        <Menu.Item key="Download">
          <div className={'downloadIcon'}>
            <img src={downloadLeft} alt="Downloadimg"></img>
              Download APP
          </div>
        </Menu.Item>
      </Menu>
    );
    // console.log(this.props);

    let UserAgentConponentProps = {
      downLoanApkUrl: downLoanApkUrl,
    };
    return (
      <header {...this.props}>
        <div className="headerWrapper">
          <span className="logobox">
            <img
              src={websiteLogo}
              className={isMobile ? "logoMobile" : "logo"}
              alt="logo"
            />
            <span className={isMobile ? "logoTipMobile" : "logoTip"}>
              ( OKApp, OKPS ){" "}
            </span>
          </span>
          {menuMode === "horizontal" ? (
            <div className={'menuBox'}>
              
              {/* <div
                className={activeHome ? "active-btn" : "button"}
                onClick={() => handleclick("Blog")}
              >
                <Button>Blog</Button>
              </div> */}
              <div
                className={activeHome ? "active-btn" : "button"}
                onClick={() => this.handleclick("Home")}
              >
                <Button>Borrow</Button>
              </div>

              <div
                className={activeFAQ ? "active-btn" : "button"}
                onClick={() => this.handleclick("FAQ")}
              >
                <Button>FAQ</Button>
              </div>

              <div
                className={activePrivacy ? "active-btn" : "button"}
                onClick={() => this.handleclick("PrivacyPolicy")}
              >
                <Button>Privacy Policy</Button>
              </div>
              
              {/* <div className={activeProduct ? 'active-btn' : 'button'} onClick={() => handleclick('product')}>
              <Button>Product</Button>
            </div> */}
              

              <div
                className={"header-download-btn"}
                onClick={() => this.handleclick("Download")}
              >
                {/* <Button>Download</Button> */}
                <div className={'downloadIcon'}>
                  <img src={downloadLeft}/>
                    Download APP
                </div>
              </div>
            </div>
          ) : (
            <Popover
              overlayClassName="popover-menu"
              placement="bottomRight"
              content={menu}
              trigger="click"
              visible={menuVisible}
              arrowPointAtCenter
              onVisibleChange={this.handleShowMenu}
            >
              <svg className="nav-phone-menu" onClick={this.handleShowMenu}>
                <use xlinkHref="#iconmenu1" />
              </svg>
            </Popover>
          )}
        </div>

      {/* {userAgentVisible && <UserAgentConponents {...UserAgentConponentProps} />} */}
      {showDownloadModal && <DownloadComponent cancelModal={()=>this.setState({showDownloadModal:false})}/>}

      </header>
    );
  }
}

export default Header;
